import { IconProps } from "react-feather";

export function Hydrogen({
  size = 24,
  color = "black",
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2886 9.76869C19.3968 11.3134 19.8961 13.2131 19.6918 15.1029C19.4873 16.9924 18.5928 18.7405 17.1801 20.0129C15.7674 21.2851 13.9354 21.9927 12.0338 21.9999C10.1319 22.0071 8.29358 21.3135 6.87119 20.0517C5.43711 18.7862 4.52461 17.0331 4.31096 15.1331C4.09731 13.2329 4.59783 11.3208 5.7152 9.76869L12.0014 1L18.2886 9.76869ZM7.37957 10.9527H7.36662C6.75669 11.8039 6.39339 12.8067 6.3164 13.8508C6.23949 14.8952 6.4517 15.9415 6.93056 16.873C7.40942 17.8044 8.13668 18.5854 9.03098 19.131C9.92527 19.6766 10.9525 19.9653 12.0003 19.9654C13.0481 19.9654 14.0763 19.6767 14.9707 19.131C15.8647 18.5854 16.5912 17.8042 17.07 16.873C17.5489 15.9415 17.7611 14.8952 17.6842 13.8508C17.6072 12.8066 17.244 11.8039 16.634 10.9527L12.0014 4.48956L7.37957 10.9527Z"
        fill={color}
      />
      <path
        d="M14.241 13.5302C14.4455 13.5303 14.6233 13.5658 14.7742 13.6371C14.9253 13.7072 15.0426 13.8033 15.125 13.9242C15.2087 14.045 15.2502 14.1804 15.2502 14.33C15.2502 14.4508 15.2255 14.5636 15.1747 14.6679C15.1253 14.7708 15.0479 14.8721 14.9437 14.9723C14.8407 15.0712 14.7067 15.1757 14.5433 15.2842L14.1774 15.5562V15.5789H15.2794V16.0937H13.2664V15.6382L14.2702 14.8363C14.3469 14.7732 14.4137 14.7164 14.4699 14.6657C14.5261 14.615 14.57 14.5635 14.6015 14.5114C14.6331 14.4592 14.649 14.4008 14.649 14.3376C14.6489 14.239 14.6079 14.1633 14.5271 14.1099C14.446 14.0563 14.3478 14.0289 14.2324 14.0289C14.1089 14.0289 14.0089 14.0592 13.9334 14.1196C13.8594 14.1786 13.8222 14.265 13.8222 14.3775H13.2146C13.2146 14.1139 13.3106 13.9066 13.5028 13.7569C13.6951 13.6058 13.9416 13.5302 14.241 13.5302Z"
        fill={color}
      />
      <path
        d="M9.94196 12.8891H11.7542V11.1481H12.6436V15.3684H11.7542V13.6252H9.94196V15.3684H9.05041V11.1481H9.94196V12.8891Z"
        fill={color}
      />
    </svg>
  );
}
